import Api from '@/services/api'

export default {
  namespaced: true,
  state: {
    credits: null,
    has_more: false,
    error_message: '',
  },

  mutations: {
    setVellos(state, data) {
      if (!state.credits) {
        state.credits = data.influencers
      } else {
        state.credits = state.credits.concat(data.influencers)
      }

      state.has_more = !!data.next_page_url
    },

    clearVellos(state) {
      state.credits = null
    },

    handleError(state, error) {
      if (error.response && error.response.data) {
        state.error_message = error.response.data.message
      }
    },
  },

  actions: {
    async getVellos({ commit }, params) {
      await Api.get(
        `questions/available?limit=${params.limit}&page=${params.page}`
      )
        .then(({ data }) => {
          commit('setVellos', data.data)
        })
        .catch((error) => {
          commit('handleError', error)
        })
    },
  },
}
